import { render, staticRenderFns } from "./MdRadioGroupCN.vue?vue&type=template&id=c894b99e&"
import script from "./MdRadioGroupCN.vue?vue&type=script&lang=js&"
export * from "./MdRadioGroupCN.vue?vue&type=script&lang=js&"
import style0 from "./MdRadioGroupCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports